import { Situation, SOPException, SOPNote } from '@hakimo-ui/hakimo/types';
import { LastEscalationInfo } from '../last-escalation-info/LastEscalationInfo';
import { LocationNotes } from '../location-notes/LocationNotes';
import { DetachableSection } from './DetachableSection';
import { SituationChips, SOPItemList } from './utils';

interface Props {
  exceptions?: SOPException[];
  notes?: SOPNote[];
  situations?: Situation[];
  onAction?: (selectedSituation: Situation) => void;
  locationId: string;
  alarmStartEpochMs?: number;
  alarmEndEpochMs?: number;
  locationTimezone?: string;
}

export function SOPFirstStep(props: Props) {
  const {
    exceptions,
    notes,
    situations,
    onAction,
    locationId,
    alarmStartEpochMs,
    alarmEndEpochMs,
    locationTimezone,
  } = props;

  return (
    <div className="text-onlight-text-2 dark:text-ondark-text-2 flex flex-col space-y-2 text-sm">
      <div className="flex items-center justify-between gap-2">
        <LastEscalationInfo locationId={locationId} layout="stacked" />
        <LocationNotes locationId={locationId} />
      </div>

      {/* Situations Section (Scrollable) */}
      {situations && situations.length > 0 && (
        <div className="py-3">
          <div className="text-onlight-text-1 dark:text-ondark-text-1 mb-1 font-sans font-semibold">
            Situations (Select if observed)
          </div>
          <SituationChips
            situations={situations}
            onSelect={onAction}
            alarmStartEpochMs={alarmStartEpochMs}
            alarmEndEpochMs={alarmEndEpochMs}
            locationTimezone={locationTimezone}
          />
        </div>
      )}

      {exceptions && exceptions.length > 0 && (
        <DetachableSection
          sectionId="exceptions"
          title="Exceptions (Do not escalate if observed)"
        >
          <SOPItemList items={exceptions} />
        </DetachableSection>
      )}

      {/* Notes Section */}
      {notes && notes.length > 0 && (
        <DetachableSection sectionId="notes" title="Notes">
          <SOPItemList items={notes} />
        </DetachableSection>
      )}
    </div>
  );
}
